import createStore from '../../../redux/factories/crud/crudFactory';
import ReportReducers from './reducers';
import statisticReportSagaCore from './saga'

export {ReportReducers, statisticReportSagaCore};

export const statisticReport = createStore('report-service/api/v2/report/statistics');
export const invoiceReport = createStore('report-service/api/v2/report/invoices');
export const userManagementReport = createStore('report-service/api/v2/report/user-management');
export const userAuditTrailReport = createStore('report-service/api/v2/report/user-audit-trails');
export const masterViewReport = createStore('report-service/api/v2/report/master-view');
export const documentAuditTrailReport = createStore('report-service/api/v2/report/document-history');

export const massUpdate = createStore('report-service/api/v2/mass-update');